export const APP_THEME = {
  id: 'finley',
  emoji: '🐬',
  label: 'Finley',
  color: '#0D9488',
  colorLight: '#E6FFFB',
  bg: 'linear-gradient(135deg, #0F2B3C 0%, #1A3D52 55%, #0D9488 100%)',
  mood: 'Ready to read!'
};

export const GAME_MODE_THEMES = {
  phonics: { ...APP_THEME, id: APP_THEME.id, color: '#0D9488', colorLight: '#E6FFFB' },
  sight: { ...APP_THEME, id: APP_THEME.id, color: '#E8614D', colorLight: '#FDEDE9' },
  stories: { ...APP_THEME, id: APP_THEME.id, color: '#0F2B3C', colorLight: '#EAF1F5' },
  bubbles: { ...APP_THEME, id: APP_THEME.id, color: '#14B8A6', colorLight: '#E8FFFB' }
};

// Backward compatibility for modules still expecting THEMES.
export const THEMES = [APP_THEME];

export const INTERESTS = [
  { id: 'dinosaurs', emoji: '🦕', label: 'Dinosaurs' },
  { id: 'space', emoji: '🚀', label: 'Space' },
  { id: 'ocean', emoji: '🌊', label: 'Ocean & Nature' },
  { id: 'animals', emoji: '🐶', label: 'Animals' },
  { id: 'sports', emoji: '🏀', label: 'Sports' },
  { id: 'magic', emoji: '🧚', label: 'Magic & Fantasy' },
  { id: 'art', emoji: '🎨', label: 'Art & Creativity' },
  { id: 'castles', emoji: '🏰', label: 'Castles & Knights' }
];

export const CHILD_INTERESTS = INTERESTS;
